module.exports = __webpack_public_path__ + "media/thumbnails/shoe-style-3-952d05aa.svg";